/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NftTracker } from './NftTracker';
import {
    NftTrackerFromJSON,
    NftTrackerFromJSONTyped,
    NftTrackerToJSON,
    NftTrackerToJSONTyped,
} from './NftTracker';

/**
 * 
 * @export
 * @interface GetNftTrackersFromGroupingResponse
 */
export interface GetNftTrackersFromGroupingResponse {
    /**
     * 
     * @type {Array<NftTracker>}
     * @memberof GetNftTrackersFromGroupingResponse
     */
    nftTrackers?: Array<NftTracker>;
}

/**
 * Check if a given object implements the GetNftTrackersFromGroupingResponse interface.
 */
export function instanceOfGetNftTrackersFromGroupingResponse(value: object): value is GetNftTrackersFromGroupingResponse {
    return true;
}

export function GetNftTrackersFromGroupingResponseFromJSON(json: any): GetNftTrackersFromGroupingResponse {
    return GetNftTrackersFromGroupingResponseFromJSONTyped(json, false);
}

export function GetNftTrackersFromGroupingResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetNftTrackersFromGroupingResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'nftTrackers': json['nftTrackers'] == null ? undefined : ((json['nftTrackers'] as Array<any>).map(NftTrackerFromJSON)),
    };
}

export function GetNftTrackersFromGroupingResponseToJSON(json: any): GetNftTrackersFromGroupingResponse {
    return GetNftTrackersFromGroupingResponseToJSONTyped(json, false);
}

export function GetNftTrackersFromGroupingResponseToJSONTyped(value?: GetNftTrackersFromGroupingResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nftTrackers': value['nftTrackers'] == null ? undefined : ((value['nftTrackers'] as Array<any>).map(NftTrackerToJSON)),
    };
}

